<template>
  <form @submit.prevent="validateBeforeSubmit">
    <div class="modal-card" style="width: 640px">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ title }}</p>
      </header>
      <section class="modal-card-body">
        <b-field label="ID" v-if="id">
          <b-input
            placeholder="ID"
            disabled
            name="id"
            v-model="model.id">
          </b-input>
        </b-field>
        <b-field
          label="Наименование ЭНК"
          :type="{'is-danger': errors.has('product_name')}"
          :message="[{
            'Обязательное поле для заполнения' : errors.firstByRule('product_name', 'required')
          }]">
          <b-input
            name="product_name"
            placeholder="Наименование ЭНК"
            icon="angle-right"
            v-validate="'required'"
            v-model="model.product_name">
          </b-input>
        </b-field>
        <b-field label="Дата создания"
          :type="{'is-danger': errors.has('date')}"
          :message="[{
            'Обязательное поле для заполнения' : errors.firstByRule('date', 'required')
          }]">
          <b-datepicker
            name="date"
            placeholder="Выберите дату"
            icon="calendar-alt"
            v-validate="'required'"
            v-model="model.date">
          </b-datepicker>
        </b-field>
        <b-field
          label="Южная широта"
          :type="{'is-danger': errors.has('southernmost_latitude')}"
          :message="[{
            'Обязательное поле для заполнения' : errors.firstByRule('southernmost_latitude', 'required'),
            'Укажите цифры' : errors.firstByRule('southernmost_latitude', 'decimal')
          }]">
          <b-input
            name="southernmost_latitude"
            placeholder="Южная широта"
            type="float"
            icon="map-marker-alt"
            v-validate="'required|decimal'"
            v-model="model.southernmost_latitude">
          </b-input>
        </b-field>
        <b-field
          label="Западная долгота"
          :type="{'is-danger': errors.has('westernmost_longitude')}"
          :message="[{
            'Обязательное поле для заполнения' : errors.firstByRule('westernmost_longitude', 'required'),
            'Укажите цифры' : errors.firstByRule('westernmost_longitude', 'decimal')
          }]">
          <b-input
            name="westernmost_longitude"
            placeholder="Западная долгота"
            type="float"
            icon="map-marker-alt"
            v-validate="'required|decimal'"
            v-model="model.westernmost_longitude">
          </b-input>
        </b-field>
        <b-field
          label="Северная широта"
          :type="{'is-danger': errors.has('northernmost_latitude')}"
          :message="[{
            'Обязательное поле для заполнения' : errors.firstByRule('northernmost_latitude', 'required'),
            'Укажите цифры' : errors.firstByRule('northernmost_latitude', 'decimal')
          }]">
          <b-input
            name="northernmost_latitude"
            placeholder="Северная широта"
            type="float"
            icon="map-marker-alt"
            v-validate="'required|decimal'"
            v-model="model.northernmost_latitude">
          </b-input>
        </b-field>
        <b-field
          label="Восточная долгота"
          :type="{'is-danger': errors.has('easternmost_longitude')}"
          :message="[{
            'Обязательное поле для заполнения' : errors.firstByRule('easternmost_longitude', 'required'),
            'Укажите цифры' : errors.firstByRule('easternmost_longitude', 'decimal')
          }]">
          <b-input
            name="easternmost_longitude"
            placeholder="Восточная долгота"
            type="float"
            icon="map-marker-alt"
            v-validate="'required|decimal'"
            v-model="model.easternmost_longitude">
          </b-input>
        </b-field>
        <b-field label="Описание ЭНК"
          :type="{'is-danger': errors.has('description_russian')}"
          :message="[{
            'Обязательное поле для заполнения' : errors.firstByRule('description_russian', 'required')
          }]">
          <b-input
            type="textarea"
            name="description_russian"
            minlength="5"
            maxlength="256"
            placeholder="Описание ЭНК"
            v-validate="'required'"
            v-model="model.description_russian">
          </b-input>
        </b-field>
        <b-field label="Категория / Группа"
          :type="{'is-danger': errors.has('group_id')}"
          :message="[{
            'Обязательное поле для заполнения' : errors.firstByRule('group_id', 'required')
          }]">
          <b-select
            placeholder="Выбирете категорию / группу"
            name="group_id"
            expanded
            v-validate="'required'"
            v-model="model.group_id">
            <option
              v-for="option in groups"
              :value="option.id"
              :key="option.id">
              {{ option.name }}
            </option>
          </b-select>
        </b-field>
        <b-field label="Тип"
          :type="{'is-danger': errors.has('type_id')}"
          :message="[{
            'Обязательное поле для заполнения' : errors.firstByRule('type_id', 'required')
          }]">
          <b-select
            placeholder="Выбирете тип"
            name="type_id"
            expanded
            v-validate="'required'"
            v-model="model.type_id">
            <option
              v-for="option in types"
              :value="option.id"
              :key="option.id">
              {{ option.name }}
            </option>
          </b-select>
        </b-field>
        <b-field label="Состояние">
          <b-select
            placeholder="Выбирете состояние"
            name="is_active"
            expanded
            v-model="model.is_active">
            <option
              v-for="option in states"
              :value="option.id"
              :key="option.id">
              {{ option.name }}
            </option>
          </b-select>
        </b-field>
      </section>
      <footer class="modal-card-foot">
        <button class="button is-primary">Сохранить</button>        
        <button class="button" type="button" @click="$parent.close()">Закрыть</button>
      </footer>
    </div>
  </form>
</template>

<script>
import Vue from 'vue'
import VeeValidate from 'vee-validate'
Vue.use(VeeValidate, {
  events: '',
});

import { EventBus } from '@/utils'

export default {
  name: 'UserForm',
  components: {
    //
  },
  props: {
    id: Number,
    title: String
  },
  data: function () {
    const groups = []
    const types = []
    const states = [
      {
        id: true,
        name: "активная"
      },
      {
        id: false,
        name: "удаленная"
      }
    ]
    return {
      groups: groups,
      types: types,
      states: states,
      model: {
        id: undefined,
        product_name: '',
        date: new Date(),
        southernmost_latitude: '',
        westernmost_longitude: '',
        northernmost_latitude: '',
        easternmost_longitude: '',
        description_russian: ''
      },
      purge_model: {
        id: undefined,
        product_name: '',
        date: new Date(),
        southernmost_latitude: '',
        westernmost_longitude: '',
        northernmost_latitude: '',
        easternmost_longitude: '',
        description_russian: ''
      }
    }
  },
  created: function() {
    //
  },
  computed: {
    //
  },
  beforeMount: function(){
    //
  },
  mounted () {
    let $this = this

    if ($this.id){
      this.$store.dispatch('getProduct', $this.id)
        .then(response => {
          let data = response.data.data;
          for(let propertyName in data) {
            if(propertyName != "date"){
              $this.model[propertyName] = data[propertyName]
            }
            else{
              $this.model[propertyName] = new Date(data[propertyName])
            }
          }
        })
        .catch(error => {
          this.model = this.purge_model
        })
    }

    this.$store.dispatch('getTypes')
      .then(response => {
        let data = response.data.data;
        data.forEach((item) => {
          this.types.push(item)
        })
      })
      .catch(error => {
        this.types = []
      })

    this.$store.dispatch('getGroups')
      .then(response => {
        let data = response.data.data;
        data.forEach((item) => {
          this.groups.push(item)
        })
      })
      .catch(error => {
        this.groups = []
      })
  },
  methods: {
    validateBeforeSubmit() {
      let $this = this
      this.$validator.validateAll().then((result) => {
        if (result) {
          $this.doUpdate()
          return;
        }
        this.$toast.open({
          message: this.$i18n.t('notify.form_error'),
          type: 'is-danger',
          position: 'is-bottom'
        })
      });
    },
    doUpdate () {
      let $this = this
      if ($this.id){
        $this.$store.dispatch('updateProduct', $this.model)
      }
      else{
        $this.$store.dispatch('createProduct', $this.model)
      }
    }
  }
}
</script>

<style scoped>
</style>
<style>
</style>